import { type GetBackAttivitaV2IdComunicazioniParams } from '@framework/api-client/api/backoffice/schemas/getBackAttivitaV2IdComunicazioniParams.ts';
import { type GetBackProcedimentiV2IdComunicazioniParams } from '@framework/api-client/api/backoffice/schemas/getBackProcedimentiV2IdComunicazioniParams.ts';
import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Flex, Pagination } from 'antd';
import type * as React from 'react';
import { useCommunicationsContext } from './context/CommunicationsContext.tsx';
import { CommunicationItemsList } from './item-list/CommunicationItemsList.tsx';
import { CommunicationLogic } from './logic/CommunicationLogic.ts';
import { CommunicationTable } from './table/CommunicationTable.tsx';
import { useCommunicationPaginationUrl } from './table/hooks/useCommunicationPaginationUrl.ts';

export type ICommunicationListQuery =
  | GetBackProcedimentiV2IdComunicazioniParams
  | GetBackAttivitaV2IdComunicazioniParams;

export interface CommunicationListProps {
  communications?: ComunicazioneDTO[];
  extra?: React.ReactNode;
  isBackoffice?: boolean;

  query: ICommunicationListQuery;
  setQuery: (query: ICommunicationListQuery) => void;
  defaultQuery: ICommunicationListQuery;

  total: number;
}

/**
 * Elenco delle comunicazioni con paginazione
 */
export function CommunicationList(props: CommunicationListProps) {
  const {
    communications,
    extra,
    query,
    total,
    defaultQuery,
    setQuery,
    isBackoffice,
  } = props;

  const { onDelete, onEdit } = useCommunicationsContext();

  const { columns, paginationOptions } = useCommunicationPaginationUrl({
    query,
    total,
    defaultQuery,
    isBackoffice,
    setQuery,
    onDelete,
    onEdit,
  });

  if (!communications) return null;

  // la tabella è visibile solo se siamo in backoffice
  const showTable = CommunicationLogic.isTableViewEnabled();

  return (
    <Flex vertical gap={16}>
      {showTable ? (
        <CommunicationTable {...props} columns={columns} />
      ) : (
        <CommunicationItemsList {...props} communications={communications} />
      )}
      <FlexRow
        right={
          <Pagination size="small" showSizeChanger {...paginationOptions} />
        }
      >
        {extra}
      </FlexRow>
    </Flex>
  );
}
